import { useEffect, useState } from "react";
import GuidedTour from "./GuidedTour";
import WelcomeModal from "./WelcomeModal";
import WhatsNewModal from "./WhatsNewModal";
import { useUserStore } from "context/useUserStore";
import { APP_VERSION } from "../../services/constants";
import SpecificAPI from "services/SpecificApi";

export default function OnboardingController() {
  const [runTour, setRunTour] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const { appUser, setAppUser } = useUserStore();

  useEffect(() => {
    if (!appUser) return;
    const seenTour = true; //localStorage.getItem("hasSeenTour");
    const savedVersion = localStorage.getItem("appVersion");
    const termsAccepted = appUser?.policies_confirmed_at != null;
    console.log("termsAccepted", termsAccepted);
    const isNewVersion = false; // savedVersion !== APP_VERSION;

    if (isNewVersion) {
      setShowWhatsNew(true);
    } else if (!termsAccepted) {
      setShowWelcome(true);
    } else if (!seenTour) {
      setRunTour(true);
    }
  }, [appUser]);

  const handleTourFinish = () => {
    localStorage.setItem("hasSeenTour", "true");
    setRunTour(false);
  };

  const handleWelcomeClose = (accepted) => {
    setShowWelcome(false);

    if (accepted) {
      localStorage.setItem("termsAccepted", "true");
      SpecificAPI.updateUserPolicyConfirmation(appUser.id, true).then((res) => {
        console.log(res.data);
        setAppUser((prev) => ({
          ...prev,
          policies_confirmed_at: res.data.policies_confirmed_at,
        }));
      });
    }

    // const seenTour = localStorage.getItem("hasSeenTour");
    // if (!seenTour) {
    //   setRunTour(true);
    // }
  };

  const handleWhatsNewClose = () => {
    localStorage.setItem("appVersion", APP_VERSION);
    setShowWhatsNew(false);

    const termsAccepted = appUser?.policies_confirmed_at != null;
    if (!termsAccepted) {
      setShowWelcome(true);
    }
  };

  return (
    <>
      <WhatsNewModal open={showWhatsNew} onClose={handleWhatsNewClose} />
      <WelcomeModal open={showWelcome} onClose={handleWelcomeClose} />
      <GuidedTour run={runTour} onFinish={handleTourFinish} />
    </>
  );
}
